import { render } from "./PdfJsEngine.vue?vue&type=template&id=4a0c1c11&scoped=true&ts=true"
import script from "./pdfJsEngineHelper.ts?vue&type=script&lang=ts"
export * from "./pdfJsEngineHelper.ts?vue&type=script&lang=ts"

import "./PdfJsEngine.vue?vue&type=style&index=0&id=4a0c1c11&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0c1c11"]])

export default __exports__